import { useState } from 'react';
import type { FormEvent } from 'react';
import { Alert, Box, Button, Card, CardContent, Stack, TextField, Typography } from '@mui/material';
import { useAuth } from '@/hooks/useAuth';

export default function ChangePasswordPage() {
  const { changePassword, authState, user } = useAuth();
  const [current, setCurrent] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [confirmation, setConfirmation] = useState<string>('');
  const [mismatch, setMismatch] = useState<boolean>(false);
  const [complete, setComplete] = useState<boolean>(false);
  const submit = async (event: FormEvent) => {
    event.preventDefault();
    if (authState.isLoading) return;
    setMismatch(password !== confirmation);
    if (password !== confirmation) return;
    const result = await changePassword(current, password);
    if (result.success) {
      setComplete(true);
      setCurrent('');
      setPassword('');
      setConfirmation('');
    }
  };
  return (
    <Box sx={{ maxWidth: 640, mx: 'auto', p: { xs: 2, md: 3 } }}>
      <Card>
        <CardContent>
          <Stack spacing={3}>
            <Typography variant="h4" component="h1">
              Change Password
            </Typography>
            {complete ? (
              <Alert severity="success">Your password has been changed.</Alert>
            ) : user?.hasUsablePassword === false ? (
              <Button component="a" href="/accounts/password/set/" variant="contained">
                Set a Password
              </Button>
            ) : (
              <Box component="form" onSubmit={submit}>
                <Stack spacing={2}>
                  <TextField
                    label="Current Password"
                    type="password"
                    required
                    fullWidth
                    autoComplete="current-password"
                    value={current}
                    disabled={authState.isLoading}
                    onChange={(event) => setCurrent(event.target.value)}
                  />
                  <TextField
                    label="New Password"
                    type="password"
                    required
                    fullWidth
                    autoComplete="new-password"
                    value={password}
                    disabled={authState.isLoading}
                    onChange={(event) => setPassword(event.target.value)}
                  />
                  <TextField
                    label="Confirm New Password"
                    type="password"
                    required
                    fullWidth
                    autoComplete="new-password"
                    value={confirmation}
                    disabled={authState.isLoading}
                    error={mismatch}
                    helperText={mismatch ? 'Passwords do not match.' : undefined}
                    onChange={(event) => {
                      setConfirmation(event.target.value);
                      setMismatch(false);
                    }}
                  />
                  {authState.error && <Alert severity="error">{authState.error}</Alert>}
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={authState.isLoading}
                    loading={authState.isLoading}
                    loadingPosition="start"
                  >
                    {authState.isLoading ? 'Changing Password…' : 'Change Password'}
                  </Button>
                </Stack>
              </Box>
            )}
            <Button component="a" href="/auth/profile">
              Return to Profile
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
